/**
 * Pravila kupovine oko vremena polaska (važe samo za današnji datum):
 *  - početna stanica linije: kupovina moguća tačno do vremena polaska;
 *  - usputna stanica: do predviđenog vremena prolaska + luft (runtime config),
 *    uz obavezno prihvatanje rizika da je autobus možda već prošao.
 * Početna stanica se prepoznaje poređenjem vremena na stanici ukrcavanja
 * (`departureTime`) sa vremenom polaska sa prve stanice (`rootDepartureTime`).
 * Bez `rootDepartureTime` važi strože pravilo (kao početna) — bolje sakriti
 * polazak nego prodati kartu za autobus koji je sigurno otišao.
 */

// Vreme polaska sa stanice ukrcavanja u ms; null kad se ne može odrediti.
export function departureMs(trip, journeyDate) {
    const raw = trip?.departureTime || trip?.departureTimeStr || "";
    if (typeof raw === "string" && /^\d{2}:\d{2}/.test(raw)) {
        if (!journeyDate) return null;
        const [h, m] = raw.split(":").map(Number);
        const d = new Date(`${journeyDate}T00:00:00`);
        d.setHours(h, m, 0, 0);
        return d.getTime();
    }
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? null : d.getTime();
}

export function isOriginStation(trip) {
    const root = trip?.rootDepartureTime;
    if (typeof root !== "string" || !/^\d{2}:\d{2}/.test(root)) return true;
    const raw = trip?.departureTime || trip?.departureTimeStr || "";
    let hhmm = null;
    if (typeof raw === "string" && /^\d{2}:\d{2}/.test(raw)) {
        hhmm = raw.slice(0, 5);
    } else {
        const d = new Date(raw);
        if (!Number.isNaN(d.getTime())) {
            hhmm = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
        }
    }
    return hhmm === null || hhmm === root.slice(0, 5);
}

// Da li je polazak još kupovina-dozvoljen u datom trenutku.
export function isPurchasable(trip, journeyDate, graceMinutes, nowMs = Date.now()) {
    const dep = departureMs(trip, journeyDate);
    if (dep === null) return true;
    const grace = isOriginStation(trip) ? 0 : graceMinutes * 60_000;
    return nowMs <= dep + grace;
}

// Da li kupovina zahteva prihvatanje rizika (usputna stanica, predviđeno
// vreme prošlo, luft još traje). Za budući datum uvek false.
export function isPassedDepartureRisk(trip, journeyDate, graceMinutes, nowMs = Date.now()) {
    if (isOriginStation(trip)) return false;
    const dep = departureMs(trip, journeyDate);
    if (dep === null) return false;
    return nowMs > dep && nowMs <= dep + graceMinutes * 60_000;
}
